import React, { lazy, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { ErrorPage } from 'Views/ErrorPage';
import SalesforceUnauthorisedError, {
  SalesforceUnauthorisedErrorType
} from 'Views/SalesforceApp/SalesforceUnauthorisedError2';

const SalesforceAppAuthenticated = lazy(() => import('Views/SalesforceApp/SalesforceAppAuthenticated'));

const SalesforceAppEntry2: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [customerId] = useState<number | null>(
    searchParams.get('customerId') ? parseInt(searchParams.get('customerId') as string) : null
  );
  const [errorCode] = useState<string | null>(searchParams.get('error'));

  return customerId ? (
    <SalesforceAppAuthenticated customerId={customerId} />
  ) : errorCode ? (
    <SalesforceUnauthorisedError type={errorCode as SalesforceUnauthorisedErrorType} />
  ) : (
    //
    // Fallback for when no customerId or error code is provided
    <ErrorPage pageMode="fullscreen" title="Problem loading the app, no customerId or error code provided" />
  );
};

export default SalesforceAppEntry2;
